/** Chat dieser Partie – sichtbar für Eigentümer und Mitglieder. */
import { Card, PageHeader } from '../components/ui';
import { ChatPanel } from '../components/ChatPanel';
import { useGame } from '../store/game';

export function Chat() {
  const gameId = useGame((s) => s.gameId);
  if (!gameId) return null;

  return (
    <div className="space-y-4">
      <PageHeader title="Chat" description="Nur für Eigentümer und Mitglieder dieser Partie sichtbar." />
      <Card>
        <ChatPanel channel={gameId} />
      </Card>
    </div>
  );
}
